import { FormControlLabel, FormControlLabelText } from "@gluestack-ui/themed";
import { ISelectLabel } from "./types";

export const SelectLabel = ({ label, light }: ISelectLabel) => {
  if (!label) return null;

  return (
    <FormControlLabel mb="$1">
      <FormControlLabelText
        light={light}
        fontFamily="Roboto"
        fontWeight={500}
        size="sm"
      >
        {label}
      </FormControlLabelText>
    </FormControlLabel>
  );
};
